import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';


export const TEXT_AREA_PLACEHOLDER = css`
  ::placeholder {
    opacity: 1;
    color: ${COLORS.FIELD_GREY};
  }
`;


export const TEXT_AREA_DISABLED = css`
  &:disabled {
    background-color: transparent;
    border-radius: 0;
    resize: none;
    padding: 0;
    pointer-events: none;
  }
`;


export const TEXT_AREA_DEFAULT = css`
  padding: 10px;
  color: ${COLORS.DARK_GREY};
  box-sizing: border-box;
  resize: vertical;
  border: none;
  border-radius: 8px;
  transition: all .5s ease;
`;


export const TEXT_AREA = css`
  ${TEXT_AREA_DEFAULT};
  ${TEXT_AREA_PLACEHOLDER};
  ${TEXT_AREA_DISABLED};
`;
